import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

export const estimationMethodPartial: Columns<any> = {
  title: 'meteringPoint.timeSeries.estimationMethod',
  key: 'estimationMethod',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    'notspecified': '',
    'sameasdaybefore': 'enum.estimationmethod.sameasdaybefore',
    'sameassevendaysbefore': 'enum.estimationmethod.sameassevendaysbefore',
    'controlmeter': 'enum.estimationmethod.controlmeter',
    'sameas1monthbefore': 'enum.estimationmethod.sameas1monthbefore',
    'ghostmeter': 'enum.estimationmethod.ghostmeter',
    'zerovaluemeteringpointdisconnected': 'enum.estimationmethod.zerovaluemeteringpointdisconnected',
    'zerovalueinsideday': 'enum.estimationmethod.zerovalueinsideday',
    'manualestimation': 'enum.estimationmethod.manualestimation',
    'manualnotspecified': 'enum.estimationmethod.manualnotspecified',
    'manualevenly': 'enum.estimationmethod.manualevenly',
    'manuallastposition': 'enum.estimationmethod.manuallastposition',
    'manualprofile': 'enum.estimationmethod.manualprofile',
    'manualothermeteringpoint': 'enum.estimationmethod.manualothermeteringpoint',
    'advancedvee': 'enum.estimationmethod.advancedvee',
    'manualadvancedvee': 'enum.estimationmethod.manualadvancedvee',
    'advancedveelookback': 'enum.estimationmethod.advancedveelookback',
    'advancedveeclustering': 'enum.estimationmethod.advancedveeclustering',
    'advancedveeevhandler': 'enum.estimationmethod.advancedveeevhandler',
    'zerovaluemeterchange': 'enum.estimationmethod.zerovaluemeterchange'
  }
}
